import { render, staticRenderFns } from "./Style.vue?vue&type=template&id=64158b1c&scoped=true&"
import script from "./Style.vue?vue&type=script&lang=js&"
export * from "./Style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64158b1c",
  null
  
)

export default component.exports